"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { setReferralCookie } from "@/lib/referral";

/**
 * Captures `?ref=` on any localized route so deep links (e.g. /courses/dsa?ref=…) persist for checkout.
 *
 * `cookieDurationDays` is the admin's `ReferralSettings.cookieDurationDays`,
 * read by the locale layout from the public platform settings and passed down
 * so the cookie's lifetime is the configured one (`docs/19` §4).
 */
export function ReferralTracker({ cookieDurationDays }: { cookieDurationDays?: number }) {
  const params = useSearchParams();

  useEffect(() => {
    const ref = params.get("ref");
    if (ref?.trim()) setReferralCookie(ref, cookieDurationDays);
  }, [params, cookieDurationDays]);

  return null;
}
